import type { Priority } from '../../enums';
import type { BaseEntityInterface } from './base-entity.interface';

export interface IssueInterface extends BaseEntityInterface {
	assigneeUserId?: number | null;
	description?: string | null;
	name: string;
	priority?: Priority;
	status?: IssueStatus;
	statusUpdatedDatetime?: Date | null;
	/** PD-13705 — portal (public) user who submitted the issue via the e-commerce portal; null for CRM-created issues. */
	submitterPublicUserId?: number | null;
	type?: IssueType | null;
}

export enum IssueStatus {
	TODO = 'To-Do',
	IN_PROGRESS = 'In Progress',
	DONE = 'Done',
}

export enum IssueType {
	QUESTION = 'Question',
	REQUEST = 'Request',
	PROBLEM = 'Problem',
	ACCOUNTING = 'Accounting',
}
